/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedExternal from './external.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'

const $nsid = 'app.bsky.embed.getEmbedExternalView'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  url: /*#__PURE__*/ l.string({ format: 'uri' }),
  uris: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' }), {
      maxLength: 4,
    }),
  ),
  canonicalUri: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  data: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<EmbedExternal.ViewArticle>(
          (() => EmbedExternal.viewArticle) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedExternal.ViewArticlePublication>(
          (() => EmbedExternal.viewArticlePublication) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedExternal.ViewGallery>(
          (() => EmbedExternal.viewGallery) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedExternal.ViewLivestream>(
          (() => EmbedExternal.viewLivestream) as any,
        ),
      ],
      false,
    ),
  ),
  view: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<EmbedExternal.View>((() => EmbedExternal.view) as any),
  ),
  associatedRefs: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
  ),
  associatedRecords: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
  ),
  unverifiedAssociatedRefs: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
  ),
  unverifiedAssociatedRecords: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Resolve one AT-URI record into the data needed to render an enhanced external embed. The records are validated against the requested `url` before any view is built. When validation passes, returns `data`, `associatedRefs` (strongRefs to embed into a post's external.associatedRefs) and the raw `associatedRecords`, plus a legacy `view` for Standard.site records only. When validation fails, only `unverifiedAssociatedRefs` and `unverifiedAssociatedRecords` are returned and no view or data is built. The response is empty (`{}`) when no record URI was usable or the record could not be resolved; clients should fall back to their own link-card rendering in that case and skip writing strongRefs to the post. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
